import { WARNING_SOURCES } from '../constants/WarningsConstants';

export const ADD_WARNING = 'ADD_WARNING';
export const ADD_WARNINGS = 'ADD_WARNINGS';
export const REMOVE_WARNING_BY_ID_AND_MESSAGE = 'REMOVE_WARNING_BY_ID_AND_MESSAGE';
export const CLEAR_WARNINGS = 'CLEAR_WARNINGS';
export const TOGGLE_WARNINGS_BY_REF = 'TOGGLE_WARNINGS_BY_REF';
export const ENABLE_ALL_WARNINGS = 'ENABLE_ALL_WARNINGS';
export const UPDATE_ALL_WARNINGS = 'UPDATE_ALL_WARNINGS';

export function clearWarnings(sourceFilter) {
  return (dispatch) =>
    dispatch({
      type: CLEAR_WARNINGS,
      sourceFilter,
    });
}

export function addWarning(warning) {
  return (dispatch) => {
    dispatch({
      type: ADD_WARNING,
      instanceId: warning.instanceId,
      controlInfo: warning.controlInfo,
      message: warning.message,
      source: warning.source ? warning.source : WARNING_SOURCES.VALIDATION,
      preventsFormSubmission:
        warning.source === WARNING_SOURCES.RULES || warning.preventsFormSubmission, // if true, WorkflowActions.onSubmitStart() will not complete
      warningEnabled: warning.warningEnabled ?? true,
    });
  };
}

export function addWarnings(warnings) {
  return (dispatch) => {
    dispatch({
      type: ADD_WARNINGS,
      warnings,
    });
  };
}

export function toggleWarningsByRef(ref, flag) {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_WARNINGS_BY_REF,
      payload: {
        ref,
        flag,
      },
    });
  };
}

export function enableWarnings() {
  return (dispatch) => {
    dispatch({
      type: ENABLE_ALL_WARNINGS,
    });
  };
}

export function removeWarningByIdAndMessage(instanceId, message) {
  return {
    type: REMOVE_WARNING_BY_ID_AND_MESSAGE,
    payload: {
      instanceId,
      message,
    },
  };
}

export const updateAllWarnings = (newWarnings) => ({
  type: UPDATE_ALL_WARNINGS,
  payload: {
    newWarnings,
  },
});
